{{#if preview}}
  <em>This is a hidden field that will include <strong>{{ name }} = {{ value }}</strong> in the submission fields.</em>
{{else}}
  <input type="hidden" name="{{prefix}}[{{name}}]" value="{{value}}">
{{/if}}
